/* eslint-disable @typescript-eslint/no-unused-vars */
import { AnalyticsCartDto, AnalyticsCartItemDto } from 'in-time-core';
import { ApiService } from '../api.service';
import { AnalyticsTracker } from './analytics-tracker';
import { AnalyticsTrackerType, PromoCodeEventArgs, PageViewEventArgs, SignUpEventArgs, ContentViewEventArgs,
  AddToCartEventArgs, InitiateCheckoutEventArgs, CompleteRegistrationEventArgs, InitiatePurchaseEventArgs,
  PurchaseCompleteEventArgs, PurchaseFailedEventArgs, PurchaseCanceledEventArgs, SearchEventArgs, ExploreEventArgs, CartItemDetails
} from './analytics.types';

export class ApiTracker extends AnalyticsTracker {
  public readonly $typeId: AnalyticsTrackerType = 'api';

  static create(
    opts: {
      apiService: ApiService
    }
  ): ApiTracker {
    return new ApiTracker(opts.apiService);
  }

  constructor(
    private readonly apiService: ApiService,
  ) { super(); }

  onInit(hasAcceptedCookies: boolean): void {
    // Nothing to do yet
  }

  onDestroy(): void {
    // Nothing to do yet
  }

  onCookiesAccepted(): void {
    // Nothing to do yet
  }

  onCookiesDeclined(): void {
    // Nothing to do yet
  }

  trackPromoCode(args: PromoCodeEventArgs): void {
    // Nothing to do yet
  }

  trackPageView(args: PageViewEventArgs): void {
    this.apiService.confirmPageView(args);
  }

  trackSignUp(args: SignUpEventArgs): void {
    // Nothing to do yet
  }

  trackContentView(args: ContentViewEventArgs): void {
    this.apiService.confirmViewContent(args);
  }

  trackAddToCart(args: AddToCartEventArgs): void {
    const analyticsCartDto = AnalyticsCartDto.create(
      {
        eventId: args.eventId,
        businessRef: args.businessRef,
        deduplicationId: args.deduplicationId,
        contents: args.cart.items
          .map((cartItemDetails: CartItemDetails) => AnalyticsCartItemDto.create({
            uniqueId: cartItemDetails.uniqueId,
            name: cartItemDetails.name,
            unitPrice: cartItemDetails.unitPrice,
            quantity: cartItemDetails.quantity,
            totalPrice: cartItemDetails.totalPrice
          }))
      }
    );

    this.apiService.confirmAddToCart(analyticsCartDto);
  }

  trackInitiateCheckout(args: InitiateCheckoutEventArgs): void {
    const analyticsCartDto = AnalyticsCartDto.create(
      {
        eventId: args.eventId,
        businessRef: args.businessRef,
        deduplicationId: args.deduplicationId,
        contents: args.cart.items
          .map((cartItemDetails: CartItemDetails) => AnalyticsCartItemDto.create({
            uniqueId: cartItemDetails.uniqueId,
            name: cartItemDetails.name,
            unitPrice: cartItemDetails.unitPrice,
            quantity: cartItemDetails.quantity,
            totalPrice: cartItemDetails.totalPrice
          }))
      }
    );

    this.apiService.confirmInitiateCheckout(analyticsCartDto);
  }

  trackCompleteRegistration(args: CompleteRegistrationEventArgs): void {
    const analyticsCartDto = AnalyticsCartDto.create(
      {
        eventId: args.eventId,
        businessRef: args.businessRef,
        deduplicationId: args.deduplicationId,
        contents: args.cart.items
          .map((cartItemDetails: CartItemDetails) => AnalyticsCartItemDto.create({
            uniqueId: cartItemDetails.uniqueId,
            name: cartItemDetails.name,
            unitPrice: cartItemDetails.unitPrice,
            quantity: cartItemDetails.quantity,
            totalPrice: cartItemDetails.totalPrice
          }))
      }
    );

    this.apiService.confirmCompleteRegistration(analyticsCartDto);
  }

  trackInitiatePurchase(args: InitiatePurchaseEventArgs): void {
    const analyticsCartDto = AnalyticsCartDto.create(
      {
        eventId: args.eventId,
        businessRef: args.businessRef,
        deduplicationId: args.deduplicationId,
        contents: args.cart.items
          .map((cartItemDetails: CartItemDetails) => AnalyticsCartItemDto.create({
            uniqueId: cartItemDetails.uniqueId,
            name: cartItemDetails.name,
            unitPrice: cartItemDetails.unitPrice,
            quantity: cartItemDetails.quantity,
            totalPrice: cartItemDetails.totalPrice
          }))
      }
    );

    this.apiService.confirmInitiatePurchase(analyticsCartDto);
  }

  trackPurchaseComplete(args: PurchaseCompleteEventArgs): void {
    const analyticsCartDto = AnalyticsCartDto.create(
      {
        eventId: args.eventId,
        businessRef: args.businessRef,
        deduplicationId: args.deduplicationId,
        contents: args.cart.items
          .map((cartItemDetails: CartItemDetails) => AnalyticsCartItemDto.create({
            uniqueId: cartItemDetails.uniqueId,
            name: cartItemDetails.name,
            unitPrice: cartItemDetails.unitPrice,
            quantity: cartItemDetails.quantity,
            totalPrice: cartItemDetails.totalPrice
          }))
      }
    );

    this.apiService.confirmPurchaseComplete(args.email ?? null, analyticsCartDto);
  }

  trackPurchaseFailed(args: PurchaseFailedEventArgs): void {
    // Nothing to do yet
  }

  trackPurchaseCanceled(args: PurchaseCanceledEventArgs): void {
    // Nothing to do yet
  }

  trackSearch(args: SearchEventArgs): void {
    this.apiService.confirmSearch(args);
  }

  trackExplore(args: ExploreEventArgs): void {
    // Nothing to do yet
  }
}
